var render = function render(){var _vm=this,_c=_vm._self._c;return _c('y-layout-body-menu',{attrs:{"aside-width":"7rem","menu":[
  {title:'基础配置',path:'/card/plugin/wholesaler/conf'},
  {title:'规则配置',path:'/card/plugin/wholesaler/mode-rule'},
  {title:'批发商管理',path:'/card/plugin/wholesaler/user'},
  {title:'激活卡订单',path:'/card/plugin/wholesaler/order'},
]}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }